"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createStandardI18nProvider = _interopRequireDefault(require("./createStandardI18nProvider"));

var _default = function _default(options) {
  var I18nProvider = (0, _createStandardI18nProvider.default)((0, _extends2.default)({}, options, {
    __localesCacheKey: 'i18n-cached-public-locales'
  }));

  if (!options || options && !options.manuallySetLocale) {
    I18nProvider.setLocale({
      locale: navigator && navigator.languages && navigator.languages[0],
      langEnabled: true
    });
  }

  return I18nProvider;
};

exports.default = _default;
module.exports = exports.default;